import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { referral } = props;

  let crumbs = [
        {name: 'General', path: 'general'},
        {name: 'Referrals', path: 'general/referrals'},
        {name: '...', path: '#'},
  ];

  if (referral != null) {
    crumbs[2] =  { name: `${referral.studentName}`, path: `general/referrals/${referral._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
